// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumText-cls1___405e0fdda2c5aedf0dd","cls2":"PremiumText-cls2___d591c1e614fe8a07129 PremiumText-cls1___405e0fdda2c5aedf0dd"};